import { getStore } from "../store/Store";
import isDeepLink from "owa-url/lib/isDeepLink";

export default function getPrimaryTabId(): string | undefined {
    return isDeepLink() ? getStore().deeplinkId?.id : getStore().primaryReadingPaneTabId?.Id;
}
